import { render, staticRenderFns } from "./AddLogoDialogNew.vue?vue&type=template&id=23af93dc&"
import script from "./AddLogoDialogNew.vue?vue&type=script&lang=js&"
export * from "./AddLogoDialogNew.vue?vue&type=script&lang=js&"
import style0 from "./AddLogoDialogNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports